export const LANGUAGES = [
  { value: 'en', label: '🇬🇧 English' },
  { value: 'uk', label: '🇺🇦 Ukrainian' },
  { value: 'ru', label: '🇷🇺 Russian' },
  { value: 'fr', label: '🇫🇷 French' },
  { value: 'es', label: '🇪🇸 Spanish' },
  { value: 'de', label: '🇩🇪 German' },
  { value: 'it', label: '🇮🇹 Italian' },
  { value: 'pl', label: '🇵🇱 Polish' },
  { value: 'ro', label: '🇷🇴 Romanian' },
  { value: 'zh', label: '🇨🇳 Chinese' },
  { value: 'hi', label: '🇮🇳 Hindi' },
  { value: 'ar', label: '🇸🇦 Arabic' },
];